import { render, staticRenderFns } from "./ReportWinloseComponent.vue?vue&type=template&id=3872fd2f&"
import script from "./ReportWinloseComponent.vue?vue&type=script&lang=js&"
export * from "./ReportWinloseComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports